import { type FC } from "react";
import LoadingScreen from "../Common/Loading/LoadingScreen";

export const ReloadForExternal: FC<{
    message: string;
}> = ({ message }) => {
    window.location.reload();

    return (
        <LoadingScreen>
            <p>{message}</p>
        </LoadingScreen>
    );
};
